/// <reference types="@angular/localize" />

import { Injector, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import '@angular/localize/init';

export let appInjector: Injector

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .then(m => appInjector = m.injector)
  .catch(err => console.error(err));
